require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/v625154/work/perspective/node_modules/core-js/modules/es7.symbol.observable.js
// module id = 336
// module chunks = 0